module.exports = __webpack_public_path__ + "media/icons/favicons/favicon-16x16-f80b78973e507289e751eb0e82f1d001.png";